import React from "react";

class LocalizationManager {
  constructor() {
    const savedLang = localStorage.getItem("userLang");
    const supportedLangs = ["en", "zh", "ja"];

    // ���o�s�����y��
    const browserLang = navigator.language.toLowerCase();
    const shortLang = browserLang.split("-")[0];

    if (savedLang && supportedLangs.includes(savedLang)) {
      // �u���ϥ� localStorage
      this.currentLang = savedLang;
    } else if (supportedLangs.includes(shortLang)) {
      this.currentLang = shortLang;
      localStorage.setItem("userLang", shortLang);
    } else {
      this.currentLang = "en";
      localStorage.setItem("userLang", "en");
    }

    this.stringMap = new Map();
    this.isLoaded = false;
    this.loadingPromise = null;
    this.subscribers = [];
  }

  async setupLocalization(lang = this.currentLang) {
    this.currentLang = lang;

    if (this.loadingPromise) return this.loadingPromise;

    this.loadingPromise = (async () => {
      try {
        const res = await fetch("/data/localization.json");
        const localData = await res.json();

        this.stringMap.clear();
        localData.strings.forEach((item) => {
          this.stringMap.set(item.key, item[this.currentLang]);
        });

        localStorage.setItem("userLang", this.currentLang);
        this.isLoaded = true;

        document.documentElement.lang = this.currentLang;
        this.applyFontByLanguage(this.currentLang);
        this.subscribers.forEach((cb) => cb(this.currentLang));
      } catch (err) {
        console.error("Failed to load localization.json", err);
      } finally {
        this.loadingPromise = null;
      }
    })();

    return this.loadingPromise;
  }

  applyFontByLanguage(lang) {
    let fontFamily = "";

    switch (lang) {
      case "ja":
        fontFamily = `"Noto Sans JP", "Hiragino Sans", "Meiryo", sans-serif`;
        break;
      case "zh":
      case "zh-tw":
        fontFamily = `"Noto Sans TC", "PingFang TC", "Microsoft JhengHei", sans-serif`;
        break;
      default:
        fontFamily = `"Roboto", "Helvetica", "Arial", sans-serif`;
    }

    const existingStyle = document.getElementById("lang-font-style");
    if (existingStyle) existingStyle.remove();

    const style = document.createElement("style");
    style.id = "lang-font-style";
    style.innerHTML = `
      html, body, * {
        font-family: ${fontFamily} !important;
      }
    `;
    document.head.appendChild(style);
  }

  subscribe(callback) {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter((cb) => cb !== callback);
    };
  }

  getLocalString(key, variables = {}) {
    // 1) fetch & fallback to the key itself
    const has = this.stringMap?.has?.(key);
    // Dev-only warning for missing translations
    if (!has && process.env.NODE_ENV !== "production") {
      console.warn(`[i18n] Missing key: ${key}`);
    }
    let raw = has ? this.stringMap.get(key) : key;

    // 2) force to string to avoid `.split` on non-strings (numbers, null, etc.)
    raw = String(raw ?? key);

    // 3) interpolate @@vars@@ (also coerced to strings)
    for (const varKey of Object.keys(variables)) {
      const re = new RegExp(`@@${varKey}@@`, "g");
      raw = raw.replace(re, String(variables[varKey] ?? ""));
    }

    // 4) your newline style: split on literal "/n" or a real newline
    const lines = raw.split(/\/n|\r?\n/);

    return lines.map((line, i) => (
      <React.Fragment key={i}>
        {String(line)
          .split(/(\*\*.*?\*\*|\*.*?\*|__.*?__)/g)
          .map((seg, j) => {
            if (
              typeof seg === "string" &&
              seg.startsWith("**") &&
              seg.endsWith("**")
            ) {
              return <b key={j}>{seg.slice(2, -2)}</b>;
            } else if (
              typeof seg === "string" &&
              seg.startsWith("*") &&
              seg.endsWith("*")
            ) {
              return <i key={j}>{seg.slice(1, -1)}</i>;
            } else if (
              typeof seg === "string" &&
              seg.startsWith("__") &&
              seg.endsWith("__")
            ) {
              return <u key={j}>{seg.slice(2, -2)}</u>;
            } else {
              return seg;
            }
          })}
        {i < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  }

  async saveSettings(lang) {
    await this.setupLocalization(lang);
  }
}

const localizationManager = new LocalizationManager();
export default localizationManager;
